var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgM08(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.1425 1.5H5.8575C3.1275 1.5 1.5 3.1275 1.5 5.8575V12.135C1.5 14.8725 3.1275 16.5 5.8575 16.5H12.135C14.865 16.5 16.4925 14.8725 16.4925 12.1425V5.8575C16.5 3.1275 14.8725 1.5 12.1425 1.5ZM8.2125 13.1325C7.995 13.35 7.5825 13.56 7.2825 13.605L5.4375 13.8675C5.37 13.875 5.3025 13.8825 5.235 13.8825C4.9275 13.8825 4.6425 13.7775 4.44 13.575C4.1925 13.3275 4.0875 12.9675 4.1475 12.57L4.41 10.725C4.455 10.4175 4.6575 10.0125 4.8825 9.795L8.2275 6.45C8.2875 6.6075 8.3475 6.765 8.43 6.945C8.505 7.1025 8.5875 7.2675 8.6775 7.4175C8.7525 7.545 8.835 7.665 8.9025 7.755C8.985 7.8825 9.0825 8.0025 9.1425 8.07C9.18 8.1225 9.21 8.16 9.225 8.175C9.4125 8.4 9.63 8.61 9.8175 8.7675C9.87 8.82 9.9 8.85 9.915 8.8575C10.0275 8.9475 10.14 9.0375 10.2375 9.105C10.3575 9.195 10.4775 9.2775 10.605 9.345C10.755 9.435 10.92 9.5175 11.085 9.6C11.2575 9.675 11.415 9.7425 11.5725 9.795L8.2125 13.1325ZM13.0275 8.3175L12.3375 9.015C12.2925 9.06 12.2325 9.0825 12.1725 9.0825C12.15 9.0825 12.12 9.0825 12.105 9.075C10.5825 8.64 9.3675 7.425 8.9325 5.9025C8.91 5.82 8.9325 5.73 8.9925 5.6775L9.69 4.98C10.83 3.84 11.9175 3.8625 13.035 4.98C13.605 5.55 13.8825 6.0975 13.8825 6.6675C13.875 7.2075 13.5975 7.7475 13.0275 8.3175Z",
    fill: "#0e131c"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgM08);
export default __webpack_public_path__ + "static/media/m_08.31552d0dd89bd6d4c409ac13e739d1ba.svg";
export { ForwardRef as ReactComponent };